import { Injectable } from "@angular/core";
import { ConfigurationModule } from "../../configuration.module";
import { ClientConfiguration } from "./client-configuration";

@Injectable({
  providedIn: ConfigurationModule,
})
export class ClientConfigurationService {
  configuration: ClientConfiguration;
  constructor() {}

  loadConfiguration(configuration) {
    this.configuration = {
      clientId:"openground-cloud-collaboration-portal"
    };
  }
}
